import styled, { keyframes } from "styled-components"

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const HeaderContainer = styled.div`
    display: flex;
    margin: 40px auto;
    margin-top: 10px;
    max-width: 900px;
    align-items: center;
    
    @media (max-width: 1000px) { 
        padding: 0 70px;
        margin-bottom: 0;
    }

    @media (max-width: 815px) { 
        
        padding: 0 70px;
        margin-bottom: 0;
    }
    
    @media (max-width: 700px) { 
        
        padding: 0 70px;
        padding-top: 25px;
        margin-bottom: 0;
    }
    
    @media (max-width: 400px) { 
        padding: 25px;
        margin-bottom: 0;
    }
`;

export const HeaderTitle = styled.h1`
    color: #e0e0e0;
    font-size: 26px;
    
    @media (max-width: 815px) {
        display: inline;
    }
    @media (max-width: 400px) {
        font-size: 17px;
    }
`;


export const HeaderNumber = styled.h1`
    font-size: 22px;
    font-weight: normal;
    margin-right: 10px;
    color: #BB86FC;

    @media (max-width: 815px) {
        display: inline;
    }
    @media (max-width: 400px) {
        font-size: 15px;
    }
`;

export const Container = styled.div`
    display: flex;
    margin: 40px auto;
    font-size: 17px;
    max-width: 900px;
    color: #969696;
    
    @media (max-width: 1000px) { 
        padding: 0 70px;
    }
    
    @media (max-width: 815px) { 
        display: block;
        margin-top: 20px;
    }
    
    @media (max-width: 700px) { 
        display: block;
        margin-top: 20px;
    }
    
    @media (max-width: 400px) {
        margin-top: 0px; 
        padding: 0px 25px;
    }
`;

export const TextContainer = styled.div`
    width: 100%;
    animation: ${fadeInUp} 0.6s ease-out forwards;

    @media (max-width: 815px) { 
        width: 100%;
        margin-bottom: 50px;
    }
`;

export const Text = styled.p`
    margin-bottom: 20px;
    font-size: 15px;
    display: inline;
    line-height: 1.6;
    transition: color 0.3s ease;

    &:hover {
        color: #e0e0e0;
    }
`;


export const Highlight = styled.p`
    color: #BB86FC;
    display: inline;
`;

export const Break = styled.div`
    height: 17px;
`;


export const ContainerList = styled.ul`
    margin-left: 30px;
    font-size: 13px;
    list-style-image: url('/list-symbol.png')
    
`;



export const Item = styled.li`
    margin-bottom: 20px;
`;

export const ProfileDiv = styled.div`
    display: grid;
    grid-template: 1fr / 1fr;

    & > *{
        grid-column: 1 / 1;
        grid-row: 1 / 1;
    }

    
    @media (max-width: 815px) { 
        width: min-content;
        margin: 0 auto;
    }
`;

export const ProfileContainer = styled.div`
    background: url('/profile.jpg') no-repeat top center;
    background-size: auto 100%;
    margin-left: 40px;
    width: 270px;
    height: 270px;
    border-radius: 3px;
    z-index: 2;
    transition: transform 0.3s ease, filter 0.3s ease;
    
    &:hover {
        transform: translate(-5px, -5px);
        filter: brightness(1.1);
    }
    
    @media (max-width: 815px) { 
        margin-left: 0;
        width: 240px;
        height: 240px;
    }
    
    @media (max-width: 300px) { 
        width: 220px;
        height: 220px;
    }
`;
export const ProfileText = styled.p`
    text-align: center;
    font-weight: bold;
    padding: 80px 0;

    
    @media (max-width: 300px) { 
        width: 220px;
        padding: 60px 0;
    }

`;


export const ProfileContainerTwo = styled.div`
    background: none;
    border: solid 3px #BB86FC;
    border-radius: 5px;
    margin-left: 60px;
    margin-top: 20px;
    width: 270px;
    height: 270px;
    z-index: 1;
    transition: transform 0.3s ease;
    
    ${ProfileContainer}:hover + & {
        transform: translate(5px, 5px);
    }
    
    @media (max-width: 815px) { 
        margin-left: 25px;
        width: 240px;
        height: 240px;
    }
    
    @media (max-width: 400px) { 
        margin-top: 8px;
        margin-left: 8px;
    }
    
    @media (max-width: 300px) { 
        width: 220px;
        height: 220px;
    }
`;

export const TechListContainer = styled.div`
    display: flex;
    gap: 40px;
    margin: 20px 0;
    
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 20px;
    }
`;

export const TechList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const TechItem = styled.li`
    position: relative;
    padding-left: 20px;
    margin-bottom: 10px;
    font-size: 14px;
    color: #969696;
    transition: transform 0.2s ease, color 0.2s ease;

    &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: #BB86FC;
    }

    &:hover {
        transform: translateX(5px);
        color: #BB86FC;
    }
`;